import { render, staticRenderFns } from "./CodeQR.vue?vue&type=template&id=005528c4&scoped=true"
import script from "./CodeQR.vue?vue&type=script&lang=js"
export * from "./CodeQR.vue?vue&type=script&lang=js"
import style0 from "@pds/typography/typography.min.css?vue&type=style&index=0&id=005528c4&prod&scoped=true&lang=css&external"
import style1 from "./CodeQR.vue?vue&type=style&index=1&id=005528c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005528c4",
  null
  
)

export default component.exports